// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableQueriesScansQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
  indexId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type SchemaTableQueriesScansQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableScans: Array<{
    __typename?: "SchemaTableScanDetail";
    id: string;
    whereExpression?: string | null;
    joinExpression?: string | null;
    avgCallsPerMinute: number;
    genericPlanScanMethod?: string | null;
    genericPlanTotalCost?: number | null;
    queries: Array<{
      __typename?: "QuerySummaryStats";
      id: string;
      truncatedQuery: string;
    }>;
  }>;
};

export const SchemaTableQueriesScansDocument = gql`
  query SchemaTableQueriesScans(
    $databaseId: ID!
    $tableId: ID!
    $indexId: ID
    $startTs: Int!
    $endTs: Int!
  ) {
    getSchemaTableScans(
      databaseId: $databaseId
      tableId: $tableId
      indexId: $indexId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      whereExpression
      joinExpression
      avgCallsPerMinute
      genericPlanScanMethod
      genericPlanTotalCost
      queries {
        id
        truncatedQuery
      }
    }
  }
`;

/**
 * __useSchemaTableQueriesScansQuery__
 *
 * To run a query within a React component, call `useSchemaTableQueriesScansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableQueriesScansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableQueriesScansQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      indexId: // value for 'indexId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useSchemaTableQueriesScansQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  > &
    (
      | { variables: SchemaTableQueriesScansQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  >(SchemaTableQueriesScansDocument, options);
}
export function useSchemaTableQueriesScansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  >(SchemaTableQueriesScansDocument, options);
}
// @ts-ignore
export function useSchemaTableQueriesScansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableQueriesScansQuery,
  SchemaTableQueriesScansQueryVariables
>;
export function useSchemaTableQueriesScansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableQueriesScansQuery,
        SchemaTableQueriesScansQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableQueriesScansQuery | undefined,
  SchemaTableQueriesScansQueryVariables
>;
export function useSchemaTableQueriesScansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableQueriesScansQuery,
        SchemaTableQueriesScansQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableQueriesScansQuery,
    SchemaTableQueriesScansQueryVariables
  >(SchemaTableQueriesScansDocument, options);
}
export type SchemaTableQueriesScansQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesScansQuery
>;
export type SchemaTableQueriesScansLazyQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesScansLazyQuery
>;
export type SchemaTableQueriesScansSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesScansSuspenseQuery
>;
export type SchemaTableQueriesScansQueryResult = Apollo.QueryResult<
  SchemaTableQueriesScansQuery,
  SchemaTableQueriesScansQueryVariables
>;
